import React from 'react';
import '../stylesh/OutcomeHome.css';

// 🔹 Image imports
// import UnifiedCloud from '../../../assets/home/Unified-cloud-home.svg';
// import Reliablesupport from '../../../assets/home/e2e-transformation-home.svg';
// import BusinessResilience from '../../../assets/home/business-resilience-home.svg';
// import AcceleratePace from '../../../assets/home/accelerate-pace-home.svg';


import Reliablesupport from '../../../assets/home/e2e-transformation-home.svg';
import EnduserExperience from '../../../assets/home/End-userExperience.png';
import Modernization from '../../../assets/home/Modernization.png';
import SecurityAndCompliance from '../../../assets/home/SecurityAndCompliance.png';

const OutcomeHome = () => {
  const benefits = [
    {
      title: "Strong security and compliance",
      description:
        "Synectiks builds security into every layer with controls, encryption and continuous monitorir. Our Zero Trust policy makes your data protected across endpoints, cloud, and virtual desktops. Our controls and processes are built to support regulated environments, with audit-ready logs and reporting aligned to frameworks such as SOC 2 and HIPAA.",
      image: SecurityAndCompliance
    },
    {
      title: "Reliable support for business continuity",
      description:
        "Your operations never sleep, and neither do we. We operate with 24/7 proactive monitoring, defined SLAs, and tested recovery processes to keep your business running. From backup and disaster recovery to secure remote access, Synectiks ensures uptime and fast restoration when incidents happen. We also have fully managed support services for customers.",
      image: Reliablesupport
    },
    {
      title: "Modernization with measurable outcomes",
      description:
        "We transform business performance and make things easy. We modernize infrastructure and apps with clear targets, faster deployments, improved performance, lower operational effort, and Optimize cost. Our standardized playbooks and automation reduce risk and variability, producing consistent, measurable improvements across environments.",
      image: Modernization
    },
    {
      title: "Proven end-user experience and unified control",
      description:
        "Empower your workforce with seamless, high-performance access. Users get a smooth, familiar workspace on any device, with high-speed access to endpoint management and virtual desktops. IT teams get a unified control plane for provisioning, policy management, monitoring, and reporting, reducing support tickets and simplifying operations.",
      image: EnduserExperience
    }
  ];

  return (
    <section className="outcome-container">
      <div className="outcome-inner">
        <h2 className="main-title">Why Synectiks?</h2>

        <div className="benefits-grid">
          {benefits.map((item, index) => (
            <div key={index} className="benefit-card">
              <div className="benefit-image">
                <img src={item.image} alt={item.title} />
              </div>

              <h3 className="benefit-title">{item.title}</h3>

              <p className="benefit-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OutcomeHome;